import React, { useState } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import BaseFilter, {
  FilterTypeEnum,
} from '../../../components/base/BaseFilter';
import { ArrayStringData } from '../../../utils';
import { TRANSACTION_APPROVED_BY, TRANSACTION_EVENT_TYPE } from '../records/TransactionList';

const TRANSACTION_USER_CRITERIA = {
  WITH1000CWP: 'Users with >= 1,000 CWP within the same calendar month',
  WITHIN90DAYS: 'Users who registered within 90 days',
};

function Filter({ backAction = () => { } }) {
  const location = useLocation();

  const parsedSearch = queryString.parse(location.search);
  const searchTransactionType = parsedSearch['transaction_type'] || '';
  const searchOfflineEventType = parsedSearch['offline_event_type'] || '';
  const searchCreateDate = parsedSearch['creation_date'] || '';
  const searchUserCriteria = parsedSearch['user_criteria'] || '';
  const searchApprovedBy = parsedSearch['approved_by'] || '';
  const searchAiStatus = parsedSearch['ai_status'] || '';
  const searchSpotCheckStatus = parsedSearch['spot_check_status'] || '';

  const [transactionType, setTransactionType] = useState(
    ArrayStringData(searchTransactionType),
  );
  const [offlineEventType, setOfflineEventType] = useState(
    ArrayStringData(searchOfflineEventType),
  );
  const [transactionDate, setTransactionDate] = useState(searchCreateDate);
  const [userCriteria, setUserCriteria] = useState(searchUserCriteria);
  const [approvedBy, setApprovedBy] = useState(ArrayStringData(searchApprovedBy));
  const [aiStatus, setAiStatus] = useState(ArrayStringData(searchAiStatus));
  const [spotCheckStatus, setSpotCheckStatus] = useState(ArrayStringData(searchSpotCheckStatus));

  const content = [
    {
      title: 'Transaction type',
      data: [
        { name: 'Barcode', pk: 'BARCODE' },
        { name: 'Take photo', pk: 'PHOTO_TAKING' },
      ],
      value: transactionType,
      setValue: setTransactionType,
      componment: FilterTypeEnum.choice,
    },
    {
      title: 'Status',
      key: 'offline_event_type',
      data: [
        { name: TRANSACTION_EVENT_TYPE.TYPE_APPROVED, pk: 'APPROVED' },
        { name: TRANSACTION_EVENT_TYPE.TYPE_RECALLED, pk: 'RECALLED' },
      ],
      value: offlineEventType,
      setValue: setOfflineEventType,
      componment: FilterTypeEnum.choice,
      className: 'fit-content-height-area',
    },
    {
      title: 'Approved by',
      key: 'approved_by',
      data: [
        { name: TRANSACTION_APPROVED_BY.AI, pk: 'AI' },
        { name: TRANSACTION_APPROVED_BY.EARNING_RULE, pk: 'EARNING_RULE' },
      ],
      value: approvedBy,
      setValue: setApprovedBy,
      componment: FilterTypeEnum.choice,
      className: 'fit-content-height-area',
    },
    {
      title: 'AI detection status',
      key: 'ai_status',
      data: [
        { name: '-', pk: 'EMPTY' },
        { name: TRANSACTION_EVENT_TYPE.TYPE_PASSED, pk: 'PASSED' },
      ],
      value: aiStatus,
      setValue: setAiStatus,
      componment: FilterTypeEnum.choice,
      className: 'fit-content-height-area',
    },
    {
      title: 'Spot check status',
      key: 'spot_check_status',
      data: [
        { name: TRANSACTION_EVENT_TYPE.TYPE_PENDING, pk: 'PENDING', },
        { name: TRANSACTION_EVENT_TYPE.TYPE_PASSED, pk: 'PASSED' },
        { name: TRANSACTION_EVENT_TYPE.TYPE_RECALLED, pk: 'RECALLED' },
      ],
      value: spotCheckStatus,
      setValue: setSpotCheckStatus,
      componment: FilterTypeEnum.choice,
      className: 'fit-content-height-area',
    },
    {
      title: 'User criteria (single selection)',
      key: 'user_criteria',
      data: [
        { name: TRANSACTION_USER_CRITERIA.WITH1000CWP, pk: '1000', },
        { name: TRANSACTION_USER_CRITERIA.WITHIN90DAYS, pk: '90' },
      ],
      value: userCriteria,
      setValue: setUserCriteria,
      componment: FilterTypeEnum.singleChoice,
    },
    {
      title: 'Creation date',
      value: transactionDate,
      setValue: setTransactionDate,
      componment: FilterTypeEnum.date,
    },
  ];

  return <BaseFilter content={content} backAction={backAction} />;
}

export default Filter;
